//#region Imports 
import React, { useEffect, useState, useContext } from 'react';
import { StyleSheet, SafeAreaView, View, Platform, ActivityIndicator, FlatList } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@react-navigation/native';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import TeacherTimeSheets from '../HRAdmin/TeacherTimeSheets';
import CustomButton from '../../../components/CustomButton/CustomButton';
import { useTimeSheets } from '../../../hooks/useTimeSheets';
import { useCompany } from '../../../hooks/useCompany';
import { HRAdminCompanyContext } from '../../../context/HRAdminCompanyContext';
//#endregion

const HomePageHRAdmin = ({ route }) => {

  //#region const definitions
  const { t } = useTranslation();
  const { selectedCompany } = useContext(HRAdminCompanyContext);
  const { getApproversList, isLoading } = useTimeSheets();
  const { getCompanies, getbranchesData } = useCompany()
  const { colors } = useTheme()
  const styles = makeStyles(colors);
  const [showTeacherPeriod, setShowTeacherPeriod] = useState(1);
  const [showTeacherPeriodApproval, setShowTeacherPeriodApproval] = useState(0);
  const [companies, setCompanies] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [taskOptions, setTaskOptions] = useState({});
  const buttonTable = [1, 2]
  //#endregion
  //#region API Call 
  const load = () => {
    getApproversList().then((appr) => {
      setApprovers(appr)
    }).catch(apprError => {
      console.log(apprError)
    })

  }
  //#endregion

  //#region UseEffects
  useEffect(() => {
    load();
  }, [showTeacherPeriod])

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      try {
        localStorage.setItem('isRefresh', "true");
        localStorage.setItem('lastVisitedScreen', 'HomePageHRAdmin');
      } catch (error) {
        console.log(error.message);
      };
    };
    if (Platform.OS === 'web') {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    };
  }, []);

  useEffect(() => {
    load()
    setShowTeacherPeriod(1)
  }, []);
  //#endregion
  return (
    <SafeAreaView style={[styles.main]}>
      {/* SubMenu */}
      <View>
        <FlatList
          horizontal
          showsHorizontalScrollIndicator={true}
          directionalLockEnabled={true}
          alwaysBounceVertical={false}
          data={buttonTable}
          contentContainerStyle={{ alignSelf: 'flex-start', marginBottom: '1%', flexGrow: 1 }}
          showsVerticalScrollIndicator={false}
          renderItem={({ index }) => {
            return (
              <SafeAreaView>
                {index == 1 && Platform.OS === 'web' && <CustomButton
                  onPress={() => {
                    setShowTeacherPeriod(1);
                    setShowTeacherPeriodApproval(0);
                  }}
                  text={t('common:teacherPeriods')}
                  iconName='clipboard-outline'
                  show={showTeacherPeriod ? 'HOME_SELECTED' : 'HOME'}
                  type={showTeacherPeriod ? 'HOME_SELECTED' : 'HOME'}
                  isGradient={showTeacherPeriod ? true : false}
                  textTop='0'
                  sz={25}
                />}
                {index == 3 && Platform.OS === 'web' && <CustomButton
                  onPress={() => {
                    setShowTeacherPeriodApproval(1);
                    setShowTeacherPeriod(0);
                  }}
                  text={t('common:teacherPeriodsApproval')}
                  iconName='checkmark-circle-outline'
                  show={showTeacherPeriodApproval ? 'HOME_SELECTED' : 'HOME'}
                  type={showTeacherPeriodApproval ? 'HOME_SELECTED' : 'HOME'}
                  textTop='0'
                  isGradient={showTeacherPeriodApproval ? true : false}
                  sz={25}
                />}
              </SafeAreaView>
            )
          }}
          keyExtractor={item => `${item}`}
        />
      </View>

      {/* Teachers Period Specific for Pascal. Remno */}
      {showTeacherPeriod ?
        <SafeAreaView style={[styles.main]}>
          <CustomLabel
            value={t('common:teacherPeriods') + ` ${selectedCompany?.description}`}
            type='MINORTITLE'
          />
          {isLoading ?
            <SafeAreaView
              style={styles.mainView}>
              <ActivityIndicator animating={true} size='large' color="#86BC25" />
            </SafeAreaView>
            :
            // ! To be updated with selected compnay from HR
            <TeacherTimeSheets
              approvers={approvers}
              company={selectedCompany}
              isApproval={false} />
          }
        </SafeAreaView> : <></>
      }
      {showTeacherPeriodApproval ?
        <SafeAreaView style={[styles.main]}>
          <CustomLabel
            value={t('common:teacherPeriodsApproval') + ` ${selectedCompany?.description}`}
            type='MINORTITLE'
          />
          {isLoading ?
            <SafeAreaView
              style={styles.mainView}>
              <ActivityIndicator animating={true} size='large' color="#86BC25" />
            </SafeAreaView>
            :
            <TeacherTimeSheets
              approvers={approvers}
              company={selectedCompany}
              isApproval={true} />
          }
        </SafeAreaView> : <></>
      }
    </SafeAreaView>
  );
}


const makeStyles = (colors, width, height) => StyleSheet.create({
  main: {
    flex: 1,
    marginTop: '1%',
    marginHorizontal: 10,
    height: Platform.OS === "web" ? (height * 60) / 100 : "95%",
  },
  scrollMain: {
    backgroundColor: 'transparent'
  },
  item: {
  },
  row: {
    flex: 1,
    flexDirection: "row"
  },

});

export default HomePageHRAdmin; 